<template>
    <div style="height: 70vh;">
        <!-- Image preview -->
        <img v-if="isImage" :src="readFromUrl" alt="" class="ts-w-full ts-h-full ts-object-contain" />

        <!-- PDF preview using modal -->
        <div v-else-if="isPdf" class="ts-w-full ts-h-full">
            <!-- Use iframe or object for PDF preview -->
            <iframe :src="readFromUrl" class="ts-w-full ts-h-full" style="border:none;"></iframe>
        </div>

        <!-- Other files download -->
        <div v-else class="ts-text-center" style="height: 70vh; padding-top:280px;">
            <p class="ts-font-semibold ts-text-gray-700">{{ getFileName }}</p>
            <a :href="fileResource.storage_path" :download="getFileName">
                <i class="fas fa-cloud-download-alt ts-text-5xl"></i>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ViewModal',
    props: {
        fileResource: {
            type: Object,
            required: true
        }
    },
    computed: {
        readFromUrl() {
            // For local uploaded files
            if (this.fileResource.file instanceof File) {
                return URL.createObjectURL(this.fileResource.file);
            }
            return this.fileResource.storage_path;
        },
        getFileName() {
            return this.fileResource.name || 'Unknown';
        },
        isImage() {
            return ['image/jpeg', 'image/png', 'image/jpg'].includes(this.fileResource.type);
        },
        isPdf() {
            return this.fileResource.type === 'application/pdf';
        }
    }
};
</script>
